import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/components/custom/empty-state';
import StudyBlock from './StudyBlock';
import StudyPlanCard from './StudyPlanCard';
import RadarChart from './RadarChart';
import { FilterSelectNative } from '@/components/custom/filter';
import BarChart from './BarChart';
import ViewStudyPlan from './ViewStudyPlan';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { Loader } from '@/components/custom/loader';
import { useSession } from '@/hooks/useSession';
import Onboarding from '@/app/components/Onboarding';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from '@/components/custom/breadcrumbs/breadcrumbs';
import { Widget, WidgetBody, WidgetHeader, WidgetTitle } from '@/components/custom/widget';
import { DashboardContent } from '@/layouts/dashboard';

function StudyPlan(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [radarScore, setRadarScore] = useState();
  const [studyPlans, setStudyPlans] = useState();
  const [selectedMatterId, setSelectedMatterId] = useState('');
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [loading, setLoading] = useState(false);
  const client = useClient();
  const { session } = useSession();
  const { path } = props;
  const profiles = session?.user?.profileNames || (session?.user && session?.user['profile-names']) || [];

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const responses = await Promise.all([client.fetch('/reports/study_plans/taxonomies'), client.fetch('/study_plans')]);
        if (responses.some(item => Boolean(item.error))) {
          toast.error('Erro ao buscar dados');
        } else {
          setStudyPlans(responses[1].data);
          setRadarScore(responses[0].data);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }

    fetchData();
  }, []);

  const filters = useFormik({
    initialValues: {
      matter: 'blank'
    }
  });

  const handeFilterSelectionBox = e => {
    const selectedId = e.target.value;
    filters.setFieldValue('matter', selectedId);
    setSelectedMatterId(selectedId);
  };

  const breadCrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: '/plano-de-estudos',
        name: 'Guia de estudos',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent variant="plain">
      {loading && <Loader />}
      {!loading && studyPlans?.length === 0 && (
        <EmptyState
          cta={{ text: 'Simulados', onClick: () => navigate('/simulados') }}
          type="content"
          title={t('emptyState.titleNoSimulation')}
          text="Responda ao simulado agora e desbloqueie seu plano de estudos personalizado! Não deixe para depois, seu futuro espera!"
        />
      )}

      {!loading && studyPlans?.length > 0 ? (
        <>
          <Breadcrumbs data={breadCrumbs} />

          <WidgetTitle className="mb-2">{t('studyPlan.select')}</WidgetTitle>
          {loading && <Loader />}
          <div
            className="tab__cards mb-12"
            style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', maxHeight: '290px', overflowY: 'auto', paddingRight: '16px' }}
          >
            {studyPlans?.map((plan, i) => (
              <StudyPlanCard
                plan={plan}
                title={`${t('studyPlan.studyPlan')} #${i + 1}`}
                key={i}
              />
            ))}
          </div>

          <Widget>
            <WidgetHeader>
              <WidgetTitle>{t('studyPlan.performaceExamsTitle')}</WidgetTitle>
            </WidgetHeader>

            <WidgetBody>
              <div
                className="page page--wrap"
                style={{ minHeight: '488px' }}
              >
                <div
                  className="page__col"
                  style={{ alignSelf: 'center' }}
                >
                  <RadarChart radarScore={{ ...radarScore, 'chart-data': radarScore?.['chart-data']?.slice(0, 3) }} />
                </div>
                <div className="page__col">
                  <div className="filter-bar filter-bar--borderless">
                    <div className="filter-bar__inner">
                      <FilterSelectNative
                        label={t('textsCommon.matters')}
                        blankLabel={t('filter.selectSubject')}
                        value={filters.values.matter}
                        onChange={handeFilterSelectionBox}
                        options={radarScore?.['chart-data'].reduce((accumulator, item) => {
                          item.data.forEach(data => {
                            const existingObject = accumulator.find(obj => obj.id === data.id);
                            if (!existingObject) {
                              accumulator.push({
                                id: data.id,
                                title: data.name
                              });
                            }
                          });
                          return accumulator;
                        }, [])}
                      />
                    </div>
                  </div>
                  {filters.values.matter === 'blank' ? (
                    <EmptyState
                      type="select"
                      text={t('emptyState.selectMatterText')}
                      variant="plain"
                    />
                  ) : (
                    <BarChart
                      matterId={selectedMatterId}
                      client={client}
                    />
                  )}
                </div>
              </div>
            </WidgetBody>
          </Widget>
        </>
      ) : null}

      <Onboarding
        show={showOnboarding}
        setShowOnboarding={setShowOnboarding}
        onClose={() => setShowOnboarding(false)}
        path={path}
        profiles={profiles}
        title={t('onboarding.titleStudyPlan')}
      />
    </DashboardContent>
  );
}
export { StudyPlan as default, StudyBlock, ViewStudyPlan };
